import React from "react";
import ProductCard from "./ProductCard";

import grinder from "../assets/grinder.jpg";
import glassPipe from "../assets/glass-pipe.jpg";
import woodTray from "../assets/wood-tray.jpg";
import vapePen from "../assets/vape-pen.jpg";
import ashtray from "../assets/ashtray.jpg";
import ledTray from "../assets/led-tray.jpg";


const products = [
  { id: 1, name: "Herbal Grinder", price: "₹2,199", image: grinder },
  { id: 2, name: "Premium Glass Pipe", price: "₹1,899", image: glassPipe },
  { id: 3, name: "Wood Rolling Tray", price: "₹999", image: woodTray },
  { id: 4, name: "Electric Vape Pen", price: "₹2,999", image: vapePen },
  { id: 5, name: "Classic Ashtray", price: "₹699", image: ashtray },
  { id: 6, name: "LED Tray", price: "₹1,599", image: ledTray },
];

export default function ProductGrid() {
  return (
    <section id="products" className="py-16 px-6 max-w-7xl mx-auto">
      <h2 className="text-3xl font-extrabold neon-text text-center mb-8">
        Featured Products
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {products.map((p) => (
          <ProductCard key={p.id} product={p} />
        ))}
      </div>
    </section>
  );
}
